var exports = {
  "w": "x112a1f60--2b0154--header",
  "n": "x112a1f60--2b0154--controls",
};

module.exports = exports;
